"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _reactSvgmt = require("react-svgmt");
var _reactZoomPanPinch = require("react-zoom-pan-pinch");
var _colorcodes = _interopRequireDefault(require("../colorcodes.json"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Remove = _interopRequireDefault(require("@mui/icons-material/Remove"));
var _FullscreenExit = _interopRequireDefault(require("@mui/icons-material/FullscreenExit"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _material = require("@mui/material");
var _individualSeats = _interopRequireDefault(require("../assets/individualSeats.json"));
var _styledTextField = _interopRequireDefault(require("../styled/styledTextField"));
require("../style.css");
var Legend = function Legend(_ref) {
  var color = _ref.color,
    title = _ref.title,
    showBorder = _ref.showBorder,
    topLegend = _ref.topLegend,
    borderColor = _ref.borderColor;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: {
      xs: topLegend && 0.5,
      sm: topLegend && 1.7
    },
    sx: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      background: color,
      width: "1.25rem",
      height: "1.25rem"
    },
    border: showBorder ? "1px solid ".concat(borderColor) : ""
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 1
  }, title));
};
var InteractiveComponentMapView = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _props$lockedSeatsByO, _paperData$customAttr, _paperData$slotData, _paperData$slotData2, _paperData$slotData3, _paperData$slotData4, _paperData$slotData5, _paperData$slotData6;
  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      // Close the Popover when the user scrolls
      setAnchorEl(null);
    };

    // Attach the scroll event listener to the window
    window.addEventListener("scroll", handleScroll);

    // Remove the event listener when the component unmounts
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  var CustomPopover = function CustomPopover(_ref2) {
    var open = _ref2.open,
      anchorEl = _ref2.anchorEl,
      children = _ref2.children,
      handleClose = _ref2.handleClose,
      anchorOrigin = _ref2.anchorOrigin;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/_react.default.createElement(_material.Popover, {
      sx: {
        pointerEvents: "none"
      }
      // disableScrollLock
      ,
      PaperProps: {
        sx: {
          borderRadius: "14px",
          width: {
            xs: "75vw",
            sm: "40vw",
            md: "40vw",
            lg: "18.188rem"
          }
        }
      },
      open: open,
      anchorEl: anchorEl,
      anchorOrigin: anchorOrigin,
      onClose: handleClose
    }, children)));
  };
  var seatToFocus = props.seatToFocus,
    image = props.image,
    colorCodes = props.colorCodes,
    bookedIds = props.bookedIds;
  var COLOR_CODES = colorCodes;
  var transformWrapperRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selectedSeatMappedToIds = _useState2[0],
    setSelectedSeatMappedToIds = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    newSelectedSeats = _useState4[0],
    setNewSelectedSeats = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    svgLoaded = _useState6[0],
    setSvgLoaded = _useState6[1];

  // #####-------To call functions from outside the component using ref --------#####

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      findPathAndNavigateWithSeatName: findPathAndNavigateWithSeatName,
      handleClose: handleClose
    };
  });
  function querySelectorPromise(_x) {
    return _querySelectorPromise.apply(this, arguments);
  } // #####-------To auto focus to any seat || to reset zoom level --------#####
  function _querySelectorPromise() {
    _querySelectorPromise = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(selector) {
      var wrapperElement, element;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              wrapperElement = document.getElementById("map-view");
              element = wrapperElement.querySelector(selector);
              return _context2.abrupt("return", element);
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return _querySelectorPromise.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (svgLoaded && seatToFocus !== "") {
      findPathAndNavigateWithSeatName(seatToFocus);
    }
    if (svgLoaded && seatToFocus === "") {
      if (transformWrapperRef !== null && transformWrapperRef !== void 0 && transformWrapperRef.current) {
        transformWrapperRef.current.resetTransform();
      }
    }
  }, [svgLoaded, image]);

  // #####------- Function to find element using seat code and zoom to the element --------#####

  var findPathAndNavigateWithSeatName = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(seatName) {
      var fromSearch,
        selector,
        element,
        _args = arguments;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fromSearch = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              selector = ["path[data-paper-data*=\"\\\"id\\\":\\\"".concat(seatName, "\\\"\"]"), "text[data-paper-data*=\"\\\"id\\\":\\\"".concat(seatName, "\\\"\"]")];
              _context.prev = 2;
              _context.next = 5;
              return querySelectorPromise(selector.join(", "));
            case 5:
              element = _context.sent;
              if (transformWrapperRef !== null && transformWrapperRef !== void 0 && transformWrapperRef.current) {
                transformWrapperRef.current.zoomToElement(element, 1.1, 200);
                setAnchorEl(null);
              }
              if (fromSearch) {
                setTimeout(function () {
                  if (!(props.lockedSeatsByOthers && props.lockedSeatsByOthers.includes(seatName))) {
                    handleShowPopup(element, true);
                  }
                }, 500);
              }
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10]]);
    }));
    return function findPathAndNavigateWithSeatName(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var selectAllSeats = ['path[data-paper-data*="\\"value\\":\\"clickable\\""]', 'text[data-paper-data*="\\"value\\":\\"clickable\\""]'];
  var bookedSeatIds = bookedIds ? Object.keys(bookedIds) : [];
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    anchorEl = _useState8[0],
    setAnchorEl = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    paperData = _useState10[0],
    setPaperData = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    isMobileSize = _useState12[0],
    setIsMobileSize = _useState12[1];
  (0, _react.useEffect)(function () {
    var mobileSizeQuery = window.matchMedia("(max-width: 768px)");
    var handleMediaQueryChange = function handleMediaQueryChange(event) {
      setIsMobileSize(event.matches);
    };
    mobileSizeQuery.addListener(handleMediaQueryChange);
    setIsMobileSize(mobileSizeQuery.matches);
    return function () {
      mobileSizeQuery.removeListener(handleMediaQueryChange);
    };
  }, []);
  var getBookingDetails = function getBookingDetails(selectedID) {
    return bookedIds && bookedIds[selectedID] || [];
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var open = Boolean(anchorEl);
  var id = open ? "simple-popover" : undefined;

  // Function to trigger on clicking/hovering/searching a seat, it will fetch seat information from the element and store in a state.

  var handleShowPopup = function handleShowPopup(event) {
    var fromSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var target = fromSearch ? event : event.target;
    var pathPaperInfo = target.getAttribute("data-paper-data") || target.parentElement.getAttribute("data-paper-data") || "";
    var pathAttributes = JSON.parse(pathPaperInfo);
    if (pathAttributes !== null && pathAttributes !== void 0 && pathAttributes.parentData) {
      if (pathAttributes !== null && pathAttributes !== void 0 && pathAttributes.parentData.unavailable) {
        setPaperData(pathAttributes === null || pathAttributes === void 0 ? void 0 : pathAttributes.parentData);
        setAnchorEl(target);
        return null;
      }
      var details = getBookingDetails(pathAttributes.parentData.id);
      var wholeData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, pathAttributes.parentData), {}, {
        slotData: details
      });
      setPaperData(wholeData);
      setAnchorEl(target);
    } else {
      if (pathAttributes !== null && pathAttributes !== void 0 && pathAttributes.unavailable) {
        setPaperData(pathAttributes);
        setAnchorEl(target);
        return null;
      }
      var _details = getBookingDetails(pathAttributes.id);
      var _wholeData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, pathAttributes), {}, {
        slotData: _details
      });
      setPaperData(_wholeData);
      setAnchorEl(target);
    }
  };
  var findStatusChipColor = function findStatusChipColor(statusCode) {
    var colorMap = {
      1: "#bee7ff",
      8: "#bac4ff",
      5: "#cef3c5",
      6: "#ffe4b0",
      3: "#e6e6e6",
      4: "#ffbaba",
      7: "#ffe4e4"
    };
    return colorMap[statusCode] || "#bee7ff";
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: "flex",
      flexDirection: "column",
      position: "relative"
    },
    height: "inherit",
    id: "map-view"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      flexGrow: "1",
      overflowY: "hidden",
      cursor: "move"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactZoomPanPinch.TransformWrapper, {
    ref: transformWrapperRef,
    initialScale: 0.5,
    minScale: 0.3,
    alignmentAnimation: {
      disabled: true
    },
    velocityAnimation: {
      disabled: true
    },
    wheel: {
      disabled: Boolean(anchorEl)
    },
    pinch: {
      disabled: Boolean(anchorEl)
    }
  }, /*#__PURE__*/_react.default.createElement(_reactZoomPanPinch.TransformComponent, {
    wrapperStyle: {
      height: "100%",
      width: "100%",
      objectFit: "contain"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactSvgmt.SvgLoader, {
    svgXML: image,
    onSVGReady: function onSVGReady() {
      return setSvgLoaded(true);
    }
  }, selectAllSeats.map(function (selector, ix) {
    return /*#__PURE__*/_react.default.createElement(_reactSvgmt.SvgProxy, Object.assign({
      key: ix,
      selector: selector,
      "stroke-width": "2",
      stroke: COLOR_CODES.available_seat_border_color,
      fill: COLOR_CODES.available_seat_color,
      class: "pointer-class",
      onClick: handleShowPopup
    }, isMobileSize ? null : {
      onMouseEnter: handleShowPopup,
      onMouseOut: handleClose
    }));
  }), /*#__PURE__*/_react.default.createElement(_reactSvgmt.SvgProxy, {
    selector: ['path[data-paper-data*="\\"unavailable\\":true"]', 'text[data-paper-data*="\\"unavailable\\":true"]'],
    stroke: COLOR_CODES.unavailable_seat_border_color,
    fill: COLOR_CODES.unavailable_seat_color
  }), bookedSeatIds.map(function (selector, ix) {
    return /*#__PURE__*/_react.default.createElement(_reactSvgmt.SvgProxy, {
      key: ix,
      selector: ['path[data-paper-data*="\\"id\\":\\"' + selector + '\\""]', 'text[data-paper-data*="\\"id\\":\\"' + selector + '\\""]'],
      stroke: COLOR_CODES.booked_seat_border_color,
      fill: COLOR_CODES.booked_seat_color
      // onClick={handleShowPopup}
      //  class="disabled-class"
    });
  }), newSelectedSeats.map(function (selector, ix) {
    return /*#__PURE__*/_react.default.createElement(_reactSvgmt.SvgProxy, {
      key: ix,
      selector: ['path[data-paper-data*="\\"id\\":\\"' + selector + '\\""]', 'text[data-paper-data*="\\"id\\":\\"' + selector + '\\""]'],
      stroke: COLOR_CODES.selected_seat_border_color,
      "stroke-width": "1",
      fill: COLOR_CODES.selected_seat_color
    });
  }), //## Mark seats as unavailable if the seats are selected by other users.
  props === null || props === void 0 ? void 0 : (_props$lockedSeatsByO = props.lockedSeatsByOthers) === null || _props$lockedSeatsByO === void 0 ? void 0 : _props$lockedSeatsByO.map(function (selector, ix) {
    return /*#__PURE__*/_react.default.createElement(_reactSvgmt.SvgProxy, {
      key: ix,
      selector: ['path[data-paper-data*="\\"id\\":\\"' + selector + '\\""]', 'text[data-paper-data*="\\"id\\":\\"' + selector + '\\""]'],
      stroke: COLOR_CODES.blocked_seat_border_color,
      fill: COLOR_CODES.blocked_seat_color,
      class: "disabled-class",
      onClick: function onClick() {},
      onMouseEnter: function onMouseEnter() {}
    });
  }))))), !props.loadingInMobileView && !isMobileSize && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      position: "absolute",
      bottom: "5%",
      right: "0.2%",
      borderColor: "transparent",
      // transform: "rotate(90deg)", // Rotate the container by 90 degrees
      // transformOrigin: "bottom right", // Set the rotation origin to the bottom right corner
      // Adjust the width as needed
      width: "60px",
      float: "right"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.ButtonGroup, {
    orientation: "vertical",
    size: "medium",
    variant: "contained",
    color: "primary",
    sx: {
      width: "20px",
      background: "transparent",
      boxShadow: "none"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    borderColor: "red",
    sx: {
      borderRadius: "20px",
      padding: "4px"
    },
    key: "one",
    onClick: function onClick() {
      return transformWrapperRef.current.zoomOut();
    }
  }, /*#__PURE__*/_react.default.createElement(_Remove.default, {
    color: "white"
  })), /*#__PURE__*/_react.default.createElement(_material.Button, {
    key: "two",
    sx: {
      padding: "4px"
    },
    onClick: function onClick() {
      return transformWrapperRef.current.zoomIn();
    }
  }, /*#__PURE__*/_react.default.createElement(_Add.default, {
    color: "white"
  })), /*#__PURE__*/_react.default.createElement(_material.Button, {
    sx: {
      borderRadius: "20px",
      padding: "4px"
    },
    key: "three",
    onClick: function onClick() {
      return transformWrapperRef.current.resetTransform();
    }
  }, /*#__PURE__*/_react.default.createElement(_FullscreenExit.default, {
    color: "white"
  })))))), /*#__PURE__*/_react.default.createElement(CustomPopover, {
    id: id,
    open: open,
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    handleClose: handleClose
  }, /*#__PURE__*/_react.default.createElement(_material.Stack, {
    spacing: 0.7,
    p: 2
  }, /*#__PURE__*/_react.default.createElement(Legend, {
    topLegend: false,
    showBorder: true,
    borderColor: paperData !== null && paperData !== void 0 && paperData.unavailable ? COLOR_CODES.unavailable_seat_border_color : bookedSeatIds.includes(paperData === null || paperData === void 0 ? void 0 : paperData.id) ? COLOR_CODES.booked_seat_border_color : COLOR_CODES.available_seat_border_color,
    color: paperData !== null && paperData !== void 0 && paperData.unavailable ? COLOR_CODES.unavailable_seat_color : bookedSeatIds.includes(paperData === null || paperData === void 0 ? void 0 : paperData.id) ? COLOR_CODES.booked_seat_color : COLOR_CODES.available_seat_color,
    title: /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "h6",
      fontWeight: 600,
      sx: {
        color: "black"
      },
      fontSize: props.loadingInMobileView ? "1.8rem" : "1.2rem"
    }, paperData === null || paperData === void 0 ? void 0 : paperData.id)
  }), (paperData === null || paperData === void 0 ? void 0 : paperData.capacity) !== 1 && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle2",
    pb: 0.5,
    color: "#4b4b4b",
    fontSize: props.loadingInMobileView ? "1.2rem" : "0.875rem"
  }, "Capacity\xA0:\xA0", /*#__PURE__*/_react.default.createElement(_Typography.default, {
    display: "inline",
    fontWeight: 600,
    color: "#4b4b4b",
    fontSize: props.loadingInMobileView ? "1.2rem" : "0.875rem"
  }, paperData === null || paperData === void 0 ? void 0 : paperData.capacity)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    style: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap"
    }
  }, paperData === null || paperData === void 0 ? void 0 : (_paperData$customAttr = paperData.customAttributes) === null || _paperData$customAttr === void 0 ? void 0 : _paperData$customAttr.filter(function (item) {
    return item.value !== "clickable";
  }).map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_material.Chip, {
      key: item.value,
      label: item.label,
      sx: {
        marginRight: "10px",
        marginBottom: "10px",
        paddingY: props.loadingInMobileView && "1.2rem",
        borderRadius: "20px",
        background: "#e1e1e1",
        fontSize: props.loadingInMobileView ? "1.2rem" : "0.875rem"
      }
    });
  })), (paperData === null || paperData === void 0 ? void 0 : paperData.slotData) && /*#__PURE__*/_react.default.createElement(_material.Stack, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle1",
    sx: {
      color: "#4b4b4b"
    },
    fontWeight: 600
  }, paperData === null || paperData === void 0 ? void 0 : (_paperData$slotData = paperData.slotData) === null || _paperData$slotData === void 0 ? void 0 : _paperData$slotData.name), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle2",
    sx: {
      color: "#4b4b4b"
    }
  }, paperData === null || paperData === void 0 ? void 0 : (_paperData$slotData2 = paperData.slotData) === null || _paperData$slotData2 === void 0 ? void 0 : _paperData$slotData2.mob), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle2",
    sx: {
      color: "#4b4b4b"
    }
  }, paperData === null || paperData === void 0 ? void 0 : (_paperData$slotData3 = paperData.slotData) === null || _paperData$slotData3 === void 0 ? void 0 : _paperData$slotData3.email), (paperData === null || paperData === void 0 ? void 0 : (_paperData$slotData4 = paperData.slotData) === null || _paperData$slotData4 === void 0 ? void 0 : _paperData$slotData4.status) && /*#__PURE__*/_react.default.createElement(_material.Chip, {
    label: paperData === null || paperData === void 0 ? void 0 : (_paperData$slotData5 = paperData.slotData) === null || _paperData$slotData5 === void 0 ? void 0 : _paperData$slotData5.status,
    sx: {
      width: "fit-content",
      background: findStatusChipColor(paperData === null || paperData === void 0 ? void 0 : (_paperData$slotData6 = paperData.slotData) === null || _paperData$slotData6 === void 0 ? void 0 : _paperData$slotData6.statusCode),
      borderRadius: "5px",
      marginTop: "15px",
      fontSize: props.loadingInMobileView ? "1.2rem" : "0.75rem",
      fontWeight: "600"
    }
  })))));
});
var _default = InteractiveComponentMapView;
exports.default = _default;